// src/utils/sortByUploaded.js

/**
 * Array.sort comparator: newest upload (`created_at`) first — the Inventory
 * table's default sort (Uploaded, descending). Items with no usable date go last.
 */
export function byUploadedDesc(a, b) {
    const aTime = new Date(a.created_at).getTime();
    const bTime = new Date(b.created_at).getTime();
    if (isNaN(aTime) && isNaN(bTime)) return 0;
    if (isNaN(aTime)) return 1;
    if (isNaN(bTime)) return -1;
    return bTime - aTime;
}
